// @material-tailwind/react components
import { Typography } from "@material-tailwind/react";

// page components
import Feature from "components/cards/feature";

export default function SectionCommnunity() {
  return (
    <section className="relative z-50 pb-64 md:pt-12">
      <div className="mx-auto w-full text-center text-[#1A237E] md:w-3/4">
        <Typography variant="h2" color="inherit" className="mb-4 font-black">
          Join our Team
        </Typography>
        <Typography color="inherit" className="text-lg font-bold opacity-60">
          Join our team at Code Crush and be a part of our mission to empower
          students with affordable coding education. We are dedicated to
          providing high-quality learning experiences that equip students with
          valuable coding skills at a minimal cost. Together, we can make a
          lasting impact on the next generation of programmers.
        </Typography>
      </div>
      <div className="mt-14 flex flex-wrap items-center">
        <div className="w-full px-4 md:w-1/3">
          <Feature
            title="Whatsapp"
            iconClass="fab fa-whatsapp"
            className="bg-gradient-to-br from-green-500 via-green-600 to-green-700 text-white shadow-2xl shadow-blue-gray-500/[0.12]"
          >
            <p className="font-bold text-white">
              Connect with us on WhatsApp to engage in real-time discussions and
              problem-solving sessions. Our platform offers the opportunity to
              address any challenges you're facing directly, fostering a dynamic
              and interactive learning experience.
            </p>
          </Feature>
        </div>

        <div className="mt-12 w-full px-4 md:mt-0 md:w-1/3">
          <Feature
            title="Telegram"
            iconClass="fab fa-telegram"
            className="bg-gradient-to-br from-blue-500 via-blue-600 to-blue-700 text-white shadow-2xl shadow-blue-gray-500/[0.12]"
          >
            <p className="font-bold text-white">
              Join our vibrant Telegram community to connect with fellow
              learners and coding enthusiasts. Engage in discussions, share
              insights, and stay updated with the latest trends in the world of
              coding. Together, we create an environment of continuous learning
              and collaboration that fuels your coding journey.
            </p>
          </Feature>
        </div>

        <div className="mt-12 w-full px-4 md:mt-0 md:w-1/3">
          <Feature
            title="X"
            iconClass="fab fa-twitter"
            className="bg-gradient-to-br from-gray-500 via-gray-600 to-gray-700 font-bold text-white shadow-2xl shadow-blue-gray-500/[0.12]"
          >
            <p className="font-bold text-white">
              Stay connected with us on Twitter to receive the latest updates,
              coding tips, and insights. Follow us for a daily dose of
              inspiration, industry news, and engaging discussions. Join the
              conversation and be a part of our growing community of learners
              and coding enthusiasts.
            </p>
          </Feature>
        </div>
      </div>
    </section>
  );
}
